
import { Router } from "@angular/router";
import { ValidationsComponent } from "src/app/shared/validations/validations.component";
import { enumFormModes, enumMessageTypes } from "../../common/common-enums";
import { commonMessage } from "../../common/common-message";
import { mapper } from "../../common/mapper";
import { GenericService } from "../../services/base/generic-service";
import { GenericEntryFormProperties } from "./generic-entry-form-properties";
import { GlobalProperties } from "src/app/global/global-properties";
import { ActivatedRoute } from '@angular/router';
import { WrapperStandardRequest, WrapperStandardRequestCustom } from "../../common/models/wrapper.model";


export class GenericEntryFormFunctions<T, S> extends GenericEntryFormProperties<T, S> {

    rowCount = 0;
    constructor(private genericService: GenericService<T>, public router: Router) {
        super();

    }

    onClickOfGenericCancelButton(event: any) {
        this.router.navigate([this.getListViewFormRouteTo]);
    };


    onClickOfGenericSaveButton(event: any) {

        let lbool_ValidateSuccess: boolean = false;
        let lbool_Success: boolean = false;
        let lArrayCommonMessages: Array<commonMessage> = new Array<commonMessage>();




        lbool_ValidateSuccess = this.ValidateEntryForm();

        if (!lbool_ValidateSuccess) {
            if (this.getMessages.length > 0) {
                // open popup with messages
                //     this.fn_OpenMessageBoard(this.getMessages);
                // this.fn_ClearMessages();
            }

            return;
        }

        lbool_Success = this.fn_Save();

        if (!lbool_Success) {

            return;
        }

        //this.app_Router.navigate([this.getVFormRouteTo]);

    };

    //Functions Declarations

    NotUndefined(value: any): boolean {

        if (value !== undefined) {
            return true;
        }
        return false;
    };

    // Function Declarations
    AddMessage(aTypeError: enumMessageTypes.TypeError, aMessage: string,) {

        let lCommonMessage: commonMessage;

        lCommonMessage = new commonMessage();
        lCommonMessage.cnum_messageType = enumMessageTypes.TypeError;
        lCommonMessage.cstr_messageText = aMessage.trim();

        this.getMessages.push(lCommonMessage);

    };

    ClearMessages() {
        this.setMessages = new Array<commonMessage>();
    }
    async PopulateEntryFormGeneric(aUrl: string, aRequestData: WrapperStandardRequestCustom<any>): Promise<Array<T>> {

        let result = this.genericService.PostAPIWithWrapperRequestAndReturnsArrayOfT(aUrl, aRequestData);
        result.then((result: any) => {
            this.setEntryFormDataSource = result.responseData;
            this.setRowCount = result.rowCount;
        })
        return await result;
    }

    onClickOfGenericPaginator(event: any, priceListNo: number, itemCode: string) {
        this.getRequestData.PageRecordCount = event.pageSize;
        this.getRequestData.PageSize = event.pageIndex + 1;
        this.getRequestData.RequestData = { priceListNo: priceListNo, itemCode: itemCode }
        this.PopulateEntryFormGeneric(this.getURLForFormModeEdit, this.getRequestData);
    }
    async PopulateEntryFormGenericForOnScrollPagination(aUrl: string, aRequestData: WrapperStandardRequestCustom<any>): Promise<T> {
        let result = await this.genericService.PostAPIWithOnScrollPaginationWrapperRequestAndReturnsArrayOfT(aUrl, aRequestData);
        // result.then((result: any) => {

        //     this.setListViewDataSourceOnScrollPagination = result.responseData;
        //     this.setCurrentPage = result.currentPage;
        //     this.setPageRecordCount = result.pageRecordCount;
        //     this.setPageSize = result.pageSize;
        //     this.setRowCount = result.rowCount;
        // })
        this.setEntryFormDataSourceOnScrollPagination = result.responseData;
        this.setCurrentPage = result.currentPage;
        this.setPageRecordCount = result.pageRecordCount;
        this.setPageSize = result.pageSize;
        this.setRowCount = result.rowCount;
        return result;
    }

    // For Form Mode -- New & Edit
    // Request is ANY, Response is T
    async PopulateGenericEntryForm(aUrl: string, aRequestData: any): Promise<Array<T>> {



        let result = this.genericService.PostAPIWithWrapperReturnsT(aUrl, aRequestData);
        result.then((result: any) => {
            // if (this.getFormMode == 0) {
            //     result.bpL_IDAssignedToInvoice = localStorage.getItem("BranchId");
            //     result.bplId = localStorage.getItem("BranchId");
            //     result.branchName = localStorage.getItem("BranchName");
            //     result.branchID = localStorage.getItem("BranchId");
            //     result.branchName = localStorage.getItem("BranchName");
            //     result.bplid = localStorage.getItem("BranchId");

            // }

            console.log('result', result)
            this.setEntryFormDataSource = result.responseData;
            this.setRowCount = result.rowCount;
            if (result.responseData.documentLines) {
                //  result.documentLines[0].gstRelevnt=result.documentLines.gstRelevnt
                this.rowCount = result.responseData.documentLines.length;
            }

        })
        return await result;

    };

    // For Form Mode -- Add & Update
    // Request is T, Response is ANY
    AddGenericEntryFormSAP(aUrl: string, aRequestData: T): any {

        let result = this.genericService.PostAPIForSAP(aUrl, aRequestData);
        result.then((result: any) => {
            this.setEntryFormDataSource = result;
            localStorage.removeItem('Absolute');
            this.formSubmittedSubject.next(result);
            if (aUrl != `${GlobalProperties.getApiUrlSap}PriceLists` && !aUrl.includes('Invoices')
                && !aUrl.includes('CreditNotes') && !aUrl.includes('StockTransfers')) {
                this.router.navigate([this.getListViewFormRouteTo]);
            }
        })

        return result;

    };

    // For Form Mode -- Add & Update
    // Request is T, Response is ANY
    UpdateGenericEntryFormSAP(aUrl: string, aRequestData: T): any {

        let result = this.genericService.PatchAPIForSAP(aUrl, aRequestData);
        result.then((result: any) => {

            if (result != null) {
                this.setEntryFormDataSource = result;

            }
            else {

                this.router.navigate([this.getListViewFormRouteTo]);

            }


        })
        return result;

    };

    SaveGenericEntryForm(aUrl: string, aRequestData: T): any {

        let result = this.genericService.PostAPIWithWrapperRequestT(aUrl, aRequestData);
        result.then((result: any) => {
            this.setEntryFormDataSource = result;
        })
        return result;

    };


    /*
        // For Form Mode - Add & Update
        fn_SaveGenericEntryFormOld() {
    
            return new Promise((resolve, reject) => {
                GlobalValues.fn_ShowSpinner();
                this.genericService.setSaveMode = this.getFormMode;
                //this.svc_GenericEFService.setSaveDataURL = this.getUpdateDataURL;
                this.genericService.fn_SaveGenericEntryFormService(this.getGuid, this.getEFModel)
                    .toPromise()
                    .then(
                        (result: any) => {
                            this.setcommonOutputWrapperModel = result;
                            GlobalValues.fn_CloseSpinner();
                            resolve(result);
                        }
                    ).catch((response: any) => {
    
                        GlobalValues.fn_CloseSpinner();
                        GlobalValues.fn_ShowToastMessage(GlobalValues.fn_GetTranslatedValue('MSGSAVF'));
                        reject('Error : ${JSON.stringify(response)}');
                    });
            });
    
        };
    */

    ValidateEntryForm(): boolean {

        return false;
    };

    fn_Save(): boolean {

        return false;
    };

    /*
        fn_OpenMessageBoard(aArrayMessages: Array<commonMessage>): void {
    
            const dialogRef = this.app_MatDialog.open(genericMessageBoardComponent, {
                width: '550px',
                data: aArrayMessages
            });
    
            dialogRef.afterClosed().subscribe(result => {
                console.log('The dialog was closed');
                //this.animal = result;
            });
        }
    */

}
